import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const baseButtonColor = '#000000';

const vuetify = new Vuetify({
	theme: {
		options: {
			customProperties: true
		},
		themes: {
			light: {
				primary: '#555555'
			},
			dark: {
				primary: '#555555'
			}
		}
	}
});
export default vuetify;
